import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// API Key interfaces
export interface ApiTokenData {
  companyId: number;
  apiToken: string;
  apiTokenRotated: string | null;
  apiTokenRotatedDate: string | null;
}

export interface ApiResponse<T> {
  status: number;
  message: string;
  data: T;
}

export interface RotateTokenResponse {
  newAccessToken: string;
  companyId: number;
  rotatedAt: string;
}

// API Key helper functions
const apiKeyApi = {
  // Get current API tokens
  getApiTokens: () => {
    return api.get("/user/company/api-tokens");
  },

  // Rotate API token
  rotateApiToken: () => {
    return api.create("/user/company/rotate-access-token", {});
  },

  // Legacy method for backward compatibility (from fakebackend_helper)
  getAPIKey: () => api.get(url.GET_API_KEY)
};

export { apiKeyApi };